import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagamentoDespesaAppRoutingModule } from './pagamento-despesa.app-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PagamentoDespesaAppRoutingModule
  ]
})
export class PagamentoDespesaAppModule { }
